import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import end from './end/end.js'
import frequency from './frequency/frequency.js'
import repeatDelete from './repeatDelete.js'

export default contract({
  repeatDelete: array([
    repeatDelete
  ]),
  end,
  frequency
})
